<template>
  <div
    id="submenu"
    class="w-container"
    :style="{ backgroundColor: backgroundColor || 'black' }"
  >
    <router-link
      :to="{
        name: basePath,
        params: { section: item.id, locale: $i18n.locale }
      }"
      v-for="item in submenuItems"
      :key="item.id"
      class="history-item text-uppercase cool-link"
      :class="{ active: item.id === selectedItem }"
      v-on:click.native="$emit('changeItem', item)"
      >{{ item.value }}</router-link
    >
  </div>
</template>

<script>
export default {
  name: "Submenu",
  props: ["submenuItems", "selectedItem", "basePath", "backgroundColor"]
};
</script>

<style scoped>
.w-container {
  max-width: 820px;
  width: 100%;
}
#submenu {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: -45px;
  color: white;
  padding: 40px;
  justify-content: space-between;
}

#submenu {
  align-self: center;
}

#submenu div {
  display: inline;
  cursor: pointer;
  text-align: center;
}

.history-item {
  text-transform: uppercase;
  font-size: 0.9em;
}

.cool-link.active {
  color: hsla(0, 0%, 100%, 0.75);
}

@media (max-width: 476px) {
  #submenu {
    padding: 20px;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
  }
}
</style>
